import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useClassNameFactory, useComposeRef } from "@contember/react-utils";
import { flatClassNameList } from "@contember/utilities";
import { Trash2Icon, PencilIcon } from "lucide-react";
import { memo, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { Box } from "../Box/Box.js";
import { Button } from "../Forms/Button/Button.js";
const ActionableBox = memo(({
  children,
  editContents,
  className: classNameProp,
  componentClassName = "actionableBox",
  onRemove,
  ...rest
}) => {
  const className = useClassNameFactory(componentClassName);
  const boxComponentClassName = useMemo(() => [...flatClassNameList(componentClassName), "box"], [componentClassName]);
  const boxRef = useRef(null);
  const [boxRefElement, setBoxRefElement] = useState(null);
  const composeRef = useComposeRef(boxRef, setBoxRefElement);
  if (editContents === void 0 && onRemove === void 0) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...rest,
      ref: composeRef,
      className: className(null, classNameProp),
      componentClassName: boxComponentClassName,
      children: [
        children,
        boxRefElement ? createPortal(/* @__PURE__ */ jsxs("ul", { className: className("actions"), contentEditable: false, children: [
          editContents && /* @__PURE__ */ jsx("li", { className: className("action"), children: /* @__PURE__ */ jsx(Dropdown, { buttonProps, children: /* @__PURE__ */ jsx(Fragment, { children: editContents }) }) }),
          onRemove && /* @__PURE__ */ jsx("li", { className: className("action"), children: /* @__PURE__ */ jsx(Button, { intent: "danger", ...commonButtonProps, onClick: onRemove, children: /* @__PURE__ */ jsx(Trash2Icon, {}) }) })
        ] }), boxRefElement) : null
      ]
    }
  );
});
ActionableBox.displayName = "ActionableBox";
const commonButtonProps = {
  borderRadius: "full",
  square: true,
  size: "small"
};
const buttonProps = {
  ...commonButtonProps,
  children: /* @__PURE__ */ jsx(PencilIcon, {})
};
export {
  ActionableBox
};
//# sourceMappingURL=ActionableBox.js.map
